fx.ns("desktop.book.edition", class BookBoard extends desktop.common.board.Board
{
    constructor(model, componentFactory, options)
    {
        super(model, componentFactory, options);
        
        this.views.push({ zoom : [25], view : new desktop.book.edition.SmallView(this) });
        this.views.push({ zoom : [100], view : new desktop.book.edition.StandardView(this) });
        this.views.push({ zoom : [125,200], view : new desktop.book.edition.LargeView(this) });

        // TODO : check if needed
        this.listenUpdates( this.model.zoom, true);
    }

    get book()
    {
        return this.data;
    }

    
    /**************************** Getters / Setters **********************/

    get currentArea()
    {
        if (!this._currentArea)
            this.resolveCurrentArea();

        return this._currentArea;
    }

    set currentArea(val)
    {
        if (this._currentArea == val || !val)
            return;

        if (this._currentArea)
        {
            this._currentArea.active = false;
            this.currentArea.activePart = "";
        }
            
        this._currentArea = val;

        if (this._currentArea)
            this._currentArea.active = true;

        this.currentElement = null;

        this.guidelines.currentArea = this._currentArea;

        if (this.model.history)
            this.model.history.currentPage =  this._currentArea.data;

        if (this._currentArea)
            this.trigger("currentAreaChanged", this._currentArea);
    }

    get currentPageIndex()
    {
        if (this._currentPage)
            return this.book.pages.indexOf( this._currentPage );
    }

    set currentPageIndex(val)
    {
        let page = this.book.pages.getItemAt( val );
        if (page)
        {
            this.currentArea = this.getAreaForPage(page.id);
            this.scrollToCurrentArea();
        }
    }

    get areas()
    {
        return this._editableAreas;
    }


    get allChilds()
    {
        if (!this.initialized || !this.cover)
            return [];

        if (!this._allChilds)
        {
            this._allChilds = [];

            this._allChilds.push( this.cover);

            this.pages.sort(function(a, b) {  
                return (a.data.number - b.data.number);
            });

            this._allChilds.push.apply(this._allChilds, this.pages);

            this._allChilds.push( this._emptyMarginElement);
        }

        return this._allChilds;
    }


    /*************************** Overrides  *************************/

    
    create()
    {
        super.create();

        this._pageDragger = new desktop.common.behaviour.PageDragger(this);
    }

    onDataEvent(event)
    {
        switch (event.type)
        {
            case "place-photos-chronologically" :
                this.popup(new common.popups.MagicPlacement(this.model));
            break;

            case "add-component" :
                if (event.detail.component_type == "text")
                    this._addTextComponent( event.detail );
                else
                if (event.detail.component_type == "photo" && event.detail.creation != "dropped")
                    this._addPhotoComponent(event.detail);
                else
                    this._addComponent(event.detail);
                break;

            case "apply-layout" :
        
                if (event.data.component_type == "theme")
                    this._applyLayoutTheme(event.detail);
                else
                    this._applyLayout(event.detail);

                event.cancel(); // so layout is not applied somewhere else

                break;
         
            case "select-page" :
                this.currentArea = this.getAreaForPage(event.detail);
                this.scrollToCurrentArea(true);
                break;

            case "text-size-updated" :
                this._onTextSizeUpdated(event);
                break;

            case "cover-updated" :
                this.currentView.update();
                break;

            case "theme-layouts-loaded" :
                this._onThemeLayoutLoaded(event);
                break;
                
            case "remove-page" :
                this._removePage(event.detail);
                break;

            case "magic-placement" :
                fx.service("AIService").createStory();
                this.model.event("photo-analyse");
                break;
        
            case "layout-auto" :
                    this._onLayoutAuto(event.detail);
                break;

            default : 
                super.onDataEvent(event);
                break;
        }
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);
        
        if (action.model == this.model.zoom)
        {
            if (action.impacts("x", "y", "scale"))
            {
                if (this.model.zoom.initial && this.currentView instanceof desktop.book.edition.LargeView)
                    this.currentView.hideOthers();

                if (this.model.zoom.value > 100)
                {
                    this.currentView.move( this.model.zoom.x, this.model.zoom.y, this.model.zoom.scale, this.model.zoom.animate);
                    this.delay(this.updateGuideLine, 500)    
                }
            }
        }
        else
        if (action.type == "addItemAt" && action.data instanceof models.ProductBookPage)
        {
            this._allChilds = null;
            
            this._newPage = new shared.stage.Page(action.data,  this.model, this)
            this._newPage.visibleAtStart = false;
            this._newPage.effect = "fade";

            let position = this.getChilds().length - 1;
            this.addEditableArea( this._newPage, {width : this.book.pageWidth * 2, height : this.book.pageHeight}, position);

            this.pages.push(this._newPage);

            let addPageComponent = new shared.components.AddPageComponent(action.data);
            addPageComponent.effect = "fade";
            position = this.getChilds().length - 1;
            this.addChild(addPageComponent, {}, "", position);
            
            this.pages.push(addPageComponent);

            if (this.model.zoom == 25)
                this._newPage.addClass("movable");
            
            if (action.history)
                this.delay(this.updateCurrentView, this._newPage ? 0 : 250);
        }
        else
        if (action.type == "removeItem" && action.data instanceof models.ProductBookPage)
        {
            this._allChilds = null;

            let area = this.getAreaForPage(action.data.id);
            this.removeEditableArea(area);

            let addRemove = this.getAddRemoveForPage(action.data.id);
            addRemove.hideDestroy();
            
            this.pages.remove(area);
            this.pages.remove(addRemove);
        }
        else
        if (action.type == "moveItem" || action.type == "moveItemAt" && action.data instanceof models.ProductBookPage)
        {
            this._allChilds = null;
            this.delay( this.updateCurrentView, action.history ? 50 : 0);
        }
        else
        // if we set page numbering, we scroll to second page and display popup
        if (action.impacts("pagenumbers") && action.model instanceof models.ProductBook && this.book.pagenumbers)
        {
            this._currentPage = this.model.history.currentPage;
            if(this.currentPageIndex === 0 || this.currentPageIndex === 1)
            {
                let page = this.book.pages.getItemAt( 2 );
                if (page)
                {
                    this.currentArea = this.getAreaForPage(page.id);
                    this.scrollToCurrentArea(true);
                }
            }
           
            this.delay(this._displayPaginationPopup, 750);
        }
    }

    contextMenu(e)
	{
        let menu = [];
        
        if (this._clipBoard)
            menu.push({label : "Coller", code : "paste"})
        
        if (e && this.currentElement && fx.dom.parent(e.target, this.currentElement.node) && this.currentElement.selectable)
        {
            if (this.currentElement.removable)
            {
                if (menu.length > 0)
                    menu.push({});

                menu.push({label : fx.text("Copier"), code : "copy"});
                menu.push({label : fx.text("Couper"), code : "cut"});
			    menu.push({label : fx.text("Supprimer"), code : "delete"});
            }
        }

        if (this.currentElement)
        {
            if (menu.length > 0)
                menu.push({});

            menu.push({label : fx.text("Sauvegarder en tant que Modèle"), code : "copy-layout"});
            
            if (menu.length > 0)
                menu.push({});

            if(!this.book.pagenumbers)
                menu.push({label : fx.text("Numéroter les pages"), code : "pagination"});
            else if(this.book.pagenumbers)
                menu.push({label : fx.text("Supprimer la numérotation"), code : "remove-pagination"});
        }

        return menu;
    }

    onContextMenu(e)
	{
        switch(e.detail.code)
		{
			case "paste":
				this._onPaste(null, e.detail.x, e.detail.y);
                break;

            case "copy":
                this._onCopy(e);
                break;
                
            case "cut":
                this._onCut(e);
                break;
			
			case "delete" :
                if (this.currentElement && this.currentElement.removable)
				    this.currentElement.data.delete();
				break;

            case "copy-layout" :
                if (this.currentArea.activePart)
                {
                    this.model.createCustomLayout(this.currentArea.data, this.currentArea.activePart);
                    this.currentElement = null;
                }
                break;

            case "pagination" :
                this.book.pagenumbers = 1;
                break;
                
            case "remove-pagination" :
                this.book.pagenumbers = 0;
                break;
        }
    }
	
    enable()
    {    
        if (this.enabled)
            return;
                
        super.enable();
        
        this.on("dragstart", this.onDraggingStart, this._pageDragger);
        this.on("dragstop", this.onDraggingStop, this._pageDragger);
        this.on("dragdrop", this.onDraggingDrop, this._pageDragger);

        this.on("updated", this.onZoomChanged, this.model.zoom);
        this.on("scrollChanged", this.onScroll);      
    }
    
    disable()
    {
        if (!this.enabled)
            return;
                
        super.disable();

        this.off("dragstart", this.onDraggingStart, this._pageDragger);
        this.off("dragstop", this.onDraggingStop, this._pageDragger);
        this.off("dragdrop", this.onDraggingDrop, this._pageDragger);

        this.off("updated", this.onZoomChanged, this.model.zoom);
        this.off("scrollChanged", this.onScroll);
    }

    
    /*************************** Events  *************************/

    onZoomChanged()
    {
        if (this.model.zoom.value < 100)
        {
            this._mouse.disable();
            this._mover.disable();
            this._resizer.disable();
            this._innerDragger.disable();

            this._pageDragger.enable();

            this.model.history.mode = "global";
        }
        else
        {
            this._mouse.enable();
            this._mover.enable();
            this._resizer.enable();
            this._innerDragger.enable();

            this._pageDragger.disable();

            this.model.history.mode = "editor";
        }

        this.currentElement = null;
        
        if (this.model.zoom.value > 100)
        {
            this.showScroll(false);
            this.updateCurrentView();
        }
        else
        {
            this.showScroll(true);
            this.updateCurrentView(true);

            if (this.model.zoom.value < 100)
                this.scroll(0);
        }

        this.removeClass("zoom-" + this._zoom);
        
        this._zoom = this.model.zoom.value;

        this.addClass("zoom-" + this._zoom);

        if (this.model.zoom.value == 100)
            this.delay(this.scrollToCurrentArea, 10);
       
    }


    onSelect(event)
    {
        let area = event.detail ? event.detail.area : event.area;
        let element = event.detail ? event.detail.element : event.element;

        if (this.model.zoom.value <= 100)
            this.currentArea = area;
            
        this.currentElement = element;

        this._mouse.selectedElement = element;
        this._mouse.selectedArea = area;

        if (this.model.zoom.value < 100)
            return;

        if (this.currentArea && event.originalEvent)
            this.currentArea.selectActivePart(event.originalEvent);
    }


    onDraggingStart()
    {
        this.addClass("dragging");
    }

    onDraggingStop(e)
    {
        this.removeClass("dragging")
    }

    onDraggingDrop(e)
    {
        this.book.movePage(e.page.data, e.overPage.data, e.side);
    }


    /*************************** Actions  *************************/

    addEditableArea(area, viewport, position)
    {
        area.autoDelete = false;
        area.options = this.options;

        position = (position !== undefined) ? position : undefined;

        this.addChild(area, viewport, "", position);

        this._editableAreas.push(area)

        this.on("select", this.onSelect, area);
    }

    removeEditableArea(area)
    {
        if (area)
        {
            this.removeChild(area, true);
            //area.hideDestroy();
            this._editableAreas.remove(area.id);

            this.off("select", this.onSelect, area);
        }
    }

    removeAllEditableAreas()
    {
        let area;
        while(area = this._editableAreas.pop())
        {
            this.off("select", this.onSelect, area);
            this.removeChild(area, true);
        }
    }

    getAddRemoveForPage(id)
    {
        let childs = this.scrollableContent.getChilds();
        for (let i = 0; i < childs.length; i++)
        {
            let child = childs[i];
            if (child instanceof shared.components.AddPageComponent && child.data.id == id)
                return child;
        }        
    }
   
    
    buildBoard()
    {
        this.removeAllEditableAreas();

        if (!this.book || !this.book.cover || !this.book.elements) return;
        
        // Cover
        this.cover = new shared.stage.Cover(this.book.cover, this.model, this);
        this.addEditableArea( this.cover, {width : this.book.coverWidth, height : this.book.coverHeight} );

        // Pages
        let pages = this.book.innerPages;
        this.pages = [];

        for (let i = 0; i < pages.length; i++)
        {
            let page = new shared.stage.Page(pages[i], this.model, this);
            page.effect = "fade";
            this.pages.push(page);
            this.addEditableArea( page, {width : this.book.pageWidth * 2, height : this.book.pageHeight} );

            let addPageComponent = new shared.components.AddPageComponent(pages[i]);
            addPageComponent.effect = "fade";
            this.pages.push(addPageComponent);
            this.addChild(addPageComponent);
        }

        // used to keep a margin at the bottom and not having any scroll problem when adding new page
        this._emptyMarginElement = new fx.components.Box("EmptyMargin");
        this.addChild(this._emptyMarginElement, {width : "80%", height : "400"});

        this.currentView.update(false);     
    }

    _scrollToCurrentPage()
    {
        if (this.currentPage)
        {
            this.currentArea = this.getAreaForPage(this.currentPage.id);
            this.scrollToCurrentArea(true);

            this._currentPage = null;
        }
    }

    // when history back/forward and current page changes
    _currentPageUpdated()
    {
        this.currentPage = this.model.history.currentPage;
    }

    _editCurrentElement()
    {
        if (this.currentElement instanceof shared.stage.components.Text)
            this.currentElement.onEdit();
    }



    updateCurrentView(noanimate)
    {
        this.disableScrollUpdates();
        this.currentView.update(!noanimate);
        this.delay(this._selectAddedPage, this._newPage ? 0 : 250);
    }

    _selectAddedPage()
    {
        if (this._newPage)
        {
            this.currentView.select(this._newPage, true);
            this._newPage = null;
        }
    }

    _displayPaginationPopup()
    {
        this.currentArea.displayPaginationPopup();
    }


    _showAddPagePopup()
    {
        this.popup(new common.popups.AddPagePopup());
        this.model.account.notificated("multiple-four")
    }

    _removePage(page)
    {
        if (this.book.canRemove)
            page.delete();
        else
            this.popup(new shared.popups.RemoveAddImpossiblePopup(this.book, "removing"));
    }

    
    resolveCurrentArea()
    {
        this.currentArea = this.views[1].view.scroll(true);
    }

    // ------ data events


    _addPhotoComponent(data)
    {
        let components = [];
        let pageWidth = this.book.pageWidth;
        let currentArea = data.area ? this.getAreaForPage(data.area) : this.currentArea;
        let photosComponents = currentArea.data.photosComponents;
        let activePartWasEmpty = false;
        let activePart = data.side || "";

        if (activePart == "")
        {
            if (currentArea.activePart == "")
            {
                activePartWasEmpty = true;
                activePart = currentArea.page.isCover || currentArea.page.isFirstPage ? "right" : "left";
            }
            else
                activePart = currentArea.activePart;
        }

        
        components = photosComponents.filter(function(a) {
            let bounding = fx.graphics.getBoundingRect(a, a.rotation);
            return (activePart == "left") ? (bounding.x < pageWidth) : (bounding.x >= pageWidth + currentArea.extraWidth);
        });

        currentArea.initLayoutData();
        
        // if cover let's find photo and changed it
        if (currentArea.page.isCover)
        {
            photosComponents = photosComponents.sort( (a, b) => (a.updateIndex || 0) - (b.updateIndex || 0) );

            if (photosComponents.length > 0)
            {
                let component = photosComponents.getItemAt(0);
                if (component.updateIndex === undefined)
                    component.updateIndex = 0;
                component.updateIndex++;
                component.content = data.content;
            }
            return;
        }

        // TODO : limiter à 4

        if (components.length > 10)
            return;

        let exist = false;
        for (let i = 0; i < components.length; i++)
        {
            if ( data.content == components.getItemAt(i).content)
            {
                exist = true;
                break;
            }
        }

        if (exist)
            return;

        components.sort( (a, b) => a.x - b.x );
        // first find if a photo component is empty, and use it
        // otherwise find layout with enougth pics
        for(let i = 0; i < components.length; i++)
        {
            let component = components.getItemAt(i);
            if (component.content == "")
            {
                component.content = data.content;
                return;
            }
        }

        // before to fill page, check if active part was empty, and if too many pics on left side
        if (activePartWasEmpty)
        {
            let leftComponents = photosComponents.filter(function(a) {
                let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                return (bounding.x < pageWidth) && a.content != "";
            });

            let rightComponents = photosComponents.filter(function(a) {
                let bounding = fx.graphics.getBoundingRect(a, a.rotation);
                return (bounding.x >= pageWidth + currentArea.extraWidth) && a.content != "";
            });
            

            if (activePart == "left" && leftComponents.length >= 4 && leftComponents.length > rightComponents.length)
            {
                activePart = "right";
                components = rightComponents;
            }
            else
            if (activePart == "right" && rightComponents.length >= 4 && rightComponents.length > leftComponents.length)
            {
                activePart = "left";
                components = leftComponents;
            }
        }


        let photos = [];
    
        for(let i = 0; i < components.length; i++)
        {
            let component = components.getItemAt(i);
            let photo = this.model.photos.find({id : component.content})
            if (photo)
                photos.push( photo )
        }

        let photo = this.model.photos.find({id : data.content});
        if (photo)
            photos.push( photo )

        let layouts = fx.service("LayoutsGenerator").getLayouts(photos);

        pageWidth = currentArea.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;
        
        currentArea.data.addPhoto( photos, activePart, pageWidth, currentArea.pageHeight, currentArea.extraWidth, layouts[0], true );
    }

    _addTextComponent(data)
    {
        let text = this.model.texts.find({id : data.contentid || data.content}, this.model);
        if (text)
        {
            data.content = text.content;
            data.content_type = text.content_type;
            data.text_color = text.text_color;
            data.font_family = text.font_family;
            data.width = text.text_width;
            data.height = text.text_height;
            data.font_size = text.font_size;
            data.align = text.align;

            if (data.area)
                this.currentArea = this.getAreaForPage(data.area);
            
            this.currentArea.addComponent( data, data.side );
        }
    
    }


    _addComponent(data)
    {
            if (data.page)
            {
                this.currentArea = this.getAreaForPage(data.page.id);
                delete data.page;
            }

            // so ToolBar and Frame are removed
            this.currentElement = null;

            if (data.area)
                this.currentArea = this.getAreaForPage(data.area);
            
            this.currentArea.addComponent( data, data.side );
        
    }
  
   _applyLayoutTheme(data)
   {
        let theme = this.model.themes.find({id : data.content});
        this.model.theme = theme;
        if (this.book.createdfrom != "THEMES")
            this.book.themeid = theme.id;

        this.currentArea.activePart = data.side || "";
        this._applyThemeLayout = true;

        this.cover.loading(true, fx.text("Chargement"));
        this.model.layouts.loadThemeLayouts(this.model, data.content);
   }

   _applyLayout(data)
   {
        if (data && data.area)
            this.currentArea = this.getAreaForPage(data.area);

        let layout = this.model.layouts.find({id : data.content});

        if (data.side)
            this.currentArea.activePart = data.side;

        this.currentArea.activePart = this.currentArea.activePart ? this.currentArea.activePart : (this.currentArea.page.isCover || this.currentArea.page.isFirstPage ? "right" : "left");
        

        this.currentArea.applyLayout( layout, this.currentArea.activePart );
   }

   _onTextSizeUpdated(event)
   {
        if (event.model instanceof models.CreationElementContent && event.model.isText) // let's check if text is not in lostBorder
        {
            
            let area = this.getAreaForPage(event.model.creation_element_id);
            if (area)
            {
                let element = area.getChildFromData(event.model);
                
                let correction = this._mover.lockOnLostBorderCoordinates( event.model.x, event.model.y, event.model.rotation, event.model.width, event.model.height, area, element);
                event.model.event("text-outside", {init : event.detail, corrected : correction.corrected});
            }
        }
   }

   _onThemeLayoutLoaded()
   {
        if (this._applyThemeLayout)
        {
            this.cover.loading(false);
            this._applyThemeLayout = false;

            let frontCoverLayout = this.model.layouts.frontCoverLayout(this.model.theme.id);
            let backCoverLayout = this.model.layouts.backCoverLayout(this.model.theme.id);

            if (this.currentArea.activePart != "")
            {
                this.currentArea.applyLayout( frontCoverLayout );
            }
            else
            {
                // merge both layouts
                let layout = frontCoverLayout.duplicate();
                for(let i = 0; i < layout.components.length; i++)
                {
                    let component = layout.components.getItemAt(i);
                    component.x += this.book.pageWidth  + this.book.sliceWidth;
                }
            
                layout.components.addItem( backCoverLayout.components );
                layout.doublepage = true;

                this.currentArea.applyLayout( layout );
            }
        
            this.trigger("cover-layout-applied");
        }
   }

   _onLayoutAuto(data)
   {
        let pageWidth = this.book.pageWidth;
        let currentArea = data.area;
        let photosComponents = currentArea.data.photosComponents;

        let components = photosComponents.filter(function(a) {
            let bounding = fx.graphics.getBoundingRect(a, a.rotation);
            return ( data.side == "left") ? (bounding.x < pageWidth) : (bounding.x >= pageWidth + currentArea.extraWidth);
        });


        let photos = [];
        
        for(let i = 0; i < components.length; i++)
        {
            let component = components.getItemAt(i);
            let photo = this.model.photos.find({id : component.content})
            if (photo)
                photos.push( photo )
        }

        let photo = this.model.photos.find({id : data.content});
        if (photo)
            photos.push( photo )

        let layouts = photos.length <= 1 ? this.model.layouts.getLayoutsWithPhotos(1, this.model.theme.id) : fx.service("LayoutsGenerator").getLayouts(photos);
        if (layouts.length == 0) return;

        let code = fx.service("LayoutsGenerator").getCode(photos)

        if (!currentArea.getLayoutData(data.side).originalLayout)
            currentArea.createOriginalLayout(data.side, code);

        let allLayouts = [currentArea.getLayoutData(data.side).originalLayout].concat(layouts);

        let uniqueLayouts = [];
        const seenLayouts = new Set();
        allLayouts.forEach(layout => {

            let key = "";
            for(let i = 0; i < layout.components.length; i++)
                key += `${Math.round(layout.components.getItemAt(i).x)}|${Math.round(layout.components.getItemAt(i).y)}|${Math.round(layout.components.getItemAt(i).width)}|${Math.round(layout.components.getItemAt(i).height)}|`;
            
            if (!seenLayouts.has(key)) {
                seenLayouts.add(key);
                uniqueLayouts.push(layout);
            }
        });
        
        if (currentArea.getLayoutData(data.side).code != code)
        {
            currentArea.getLayoutData(data.side).code = code;
            currentArea.getLayoutData(data.side).position = 1;
        }
        else
            currentArea.getLayoutData(data.side).position++;

        if (currentArea.getLayoutData(data.side).position >= uniqueLayouts.length)
            currentArea.getLayoutData(data.side).position = 0;

        pageWidth = currentArea.page.isCover ? this.book.pageWidth + this.book.sliceWidth : this.book.pageWidth;
        currentArea.data.addPhoto( photos, data.side, pageWidth, currentArea.pageHeight, currentArea.extraWidth, uniqueLayouts[currentArea.getLayoutData(data.side).position ], false );                    
   }

   updateGuideLine()
   {
       this.guidelines.move(this.model.zoom.x, this.model.zoom.y, this.currentArea.scale * this.model.zoom.realValue);
   }


    // We override mouse wheel event when zoom == 100, so use can scroll page to page
    /*_onMouseWheel(e)
    {
        if (this.data.zoom.value == 100)
        {
            if (this._smoothScrollEnabled || !e.deltaY || Math.abs(e.deltaY) < 100) // disable scroll to next/previous on trackpad and 
            {
                this._smoothScrollEnabled = true;
                return false;
            }
           
            e.preventDefault();

            let index = this.book.elements.indexOf( this.currentArea.data );
            if (e.deltaY > 0)
            {
                if (index < (this.book.elements.length - 1))
                    index++;
            }
            else
            {
                if (index > 0)
                    index--;
            }

            let page = this.book.elements.getItemAt( index );
            this.currentArea = this.getAreaForPage(page.id);
            
            this.scrollToCurrentArea(true);
        }
    }*/

});